import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nProvider } from '@/i18n/I18nProvider';
import { ThemedRoot } from '@/components/ThemedRoot';
import { SessionProvider } from '@/session/SessionProvider';
import { applyThemeVars, resolveTheme } from '@/theme/cssVars';
import { ThemeProvider } from '@/theme/ThemeContext';
import { ThemeFetcher } from '@/theme/ThemeFetcher';
import App from './App';
import '@/theme/global.css';

// Paint the correct theme variables before first render (avoids a flash).
applyThemeVars(resolveTheme());

// Provider order: i18n (locale + dir) → theme (reads dir for AntD RTL) → router → session (reads
// setLocale to adopt the session's locale) → app. The router basename is DERIVED from Vite's base
// (`import.meta.env.BASE_URL`) so it tracks the deploy topology automatically: `/room` when co-hosted
// under `base:'/room/'` (the default), and `/` when the app is served at the subdomain root
// (`VITE_DATAROOM_BASE=/`, dataroom.opsflow.linkzar.com). The invite token rides in the `?t=` query.
const routerBase = import.meta.env.BASE_URL.replace(/\/+$/, '') || '/';
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <I18nProvider>
      <ThemeProvider>
        <ThemedRoot>
          <BrowserRouter basename={routerBase}>
            <SessionProvider>
              <ThemeFetcher />
              <App />
            </SessionProvider>
          </BrowserRouter>
        </ThemedRoot>
      </ThemeProvider>
    </I18nProvider>
  </StrictMode>,
);
